type Result = ModelHookResult<{
	minimumSize: number;
}>;
export function useMinimumIdeaSize(): Result {
	return {
		data: { minimumSize: 10 },
	};
}
